import { Link } from '@tanstack/react-router'
import { isExactNavMatch } from '@/shared/hooks/use-active-nav-index'
import { useSideNav } from './side-nav.hook'

export type { SideNavItem } from './side-nav.hook'

const ITEM_CLASS =
  'relative flex h-10 items-center rounded-lg px-3.5 text-sm leading-[1.125rem] text-neutral-600 transition-colors not-data-[status=active]:hover:bg-neutral-50 data-[status=active]:font-bold data-[status=active]:text-indigo-base'

const INDICATOR_CLASS =
  'pointer-events-none absolute inset-x-0 top-0 h-10 rounded-lg bg-indigo-50 transition-[transform,opacity] motion-reduce:transition-none'

export function SideNav() {
  const { items, ariaLabel, hasActive, indicatorStyle } = useSideNav()

  return (
    <nav aria-label={ariaLabel} className="relative flex w-40 flex-col gap-2">
      <span
        aria-hidden
        className={`${INDICATOR_CLASS} ${hasActive ? 'opacity-100' : 'opacity-0'}`}
        style={indicatorStyle}
        data-testid="side-nav-indicator"
      />
      {items.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          activeOptions={{ exact: isExactNavMatch(item.to) }}
          className={ITEM_CLASS}
          data-testid={item.testId}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  )
}
